<template>
	<DropdownCustom ref="dropdownCustom" :toggleIcon="false" equalWidth>
		<div class="show-content show-content-multi">
			<span class="trigger-text">{{triggerText}}</span>
			<i class="fa fa-caret-down"></i>
		</div>
		<div class="accountDateMultiChoose" slot="content">
			<div class="multi-head">
				<span @click="selectAllYear" class="text-hover">全选本季</span>
				<span @click="clearYear" class="text-hover">清空本季</span>
			</div>
			<Row type="flex" v-if="years.length > 1">
				<Cell>
					<div class="text-hover" :class="{selected:selectedYear===y}" @click="selectedYear=y" v-for="y in years" :key="y" style="padding: 5px 10px;">{{y}}年</div>
				</Cell>
				<Cell :flex="1" class="split-line">
					<ul class="list-item" v-for="y in years" v-if="selectedYear===y" :key="y">
						<li v-for="month in checkDateObject[y]" :key="y+month" @click="toggle(y,month)" :class="{'selected':isSelected(y,month)}">
							<input type="checkbox" :checked="isSelected(y,month)" @click.stop>
							第{{month}}期
						</li>
					</ul>
				</Cell>
			</Row>
			<ul class="list-item" v-else>
				<li v-for="c in User.checkoutList" :key="c.id" @click="toggle(c.checkYear,c.checkMonth)" :class="{'selected':isSelected(c.checkYear,c.checkMonth)}">
					<input type="checkbox" :checked="isSelected(c.checkYear,c.checkMonth)" @click.stop>
					{{c.checkYear}}年第{{c.checkMonth}}期
				</li>
			</ul>
		</div>
	</DropdownCustom>
</template>

<script>
	import {mapState} from 'vuex'
	import moment from 'moment'

	export default {
		name: "AccountDateMultiChoose",
		props: {
			value: {type: Array, default: () => []}
		},
		computed: {
			...mapState(['currentAccountSets', 'User']),
			checkDateObject() {
				let data = {};
				this.User.checkoutList.forEach(item => {
					if (!data[item.checkYear]) {
						data[item.checkYear] = [];
					}
					data[item.checkYear].push(item.checkMonth);
				});
				Object.keys(data).forEach((value) => {
					data[value] = data[value].sort((a, b) => a - b);
				});
				return data;
			},
			years() {
				return Object.keys(this.checkDateObject).sort((a, b) => b - a);
			},
			triggerText() {
				let len = this.value.length;
				if (len === 0) {
					return '请选择期间';
				}
				if (len === 1) {
					let ym = this.value[0].split('-');
					return `${ym[0]}年第${parseInt(ym[1])}期`;
				}
				return `已选${len}期`;
			}
		},
		data() {
			return {
				selectedYear: null
			}
		},
		methods: {
			periodKey(year, month) {
				return `${year}-${month}`;
			},
			isSelected(year, month) {
				return this.value.indexOf(this.periodKey(year, month)) >= 0;
			},
			toggle(year, month) {
				let key = this.periodKey(year, month);
				let arr = Array.from(this.value);
				let idx = arr.indexOf(key);
				if (idx >= 0) {
					//至少保留一期，避免意外空查询
					if (arr.length === 1) {
						return;
					}
					arr.splice(idx, 1);
				} else {
					arr.push(key);
				}
				this.$emit('input', arr);
			},
			selectAllYear() {
				let months = this.checkDateObject[this.selectedYear] || [];
				let arr = Array.from(this.value);
				months.forEach(m => {
					let key = this.periodKey(this.selectedYear, m);
					if (arr.indexOf(key) < 0) {
						arr.push(key);
					}
				});
				this.$emit('input', arr);
			},
			clearYear() {
				if (this.selectedYear == null) {
					return;
				}
				let arr = Array.from(this.value).filter(key => key.split('-')[0] !== String(this.selectedYear));
				if (arr.length === 0) {
					//清空后至少保留本季第一期
					let months = this.checkDateObject[this.selectedYear] || [];
					if (months.length) {
						arr.push(this.periodKey(this.selectedYear, months[0]));
					}
				}
				this.$emit('input', arr);
			}
		},
		mounted() {
			this.selectedYear = this.years[0];
			if (!this.value.length && this.currentAccountSets && this.currentAccountSets.currentAccountDate) {
				this.$emit('input', [moment(this.currentAccountSets.currentAccountDate).format('YYYY-M')]);
			}
		}
	}
</script>

<style lang="less">
	.show-content-multi {
		background: @primary-color;
		color: @white-color;
		cursor: pointer;
		border-radius: @border-radius;
		display: flex;
		align-items: center;

		.trigger-text {
			padding: 5px 10px;
			display: inline-block;
		}

		.fa {
			padding: 0 8px;
		}
	}

	.accountDateMultiChoose {
		overflow-y: auto;
		max-height: 300px;
		// 触发器很窄(equalWidth 让面板=触发器宽度)，65px年份列+110px月份列并排放不下会被 flex-wrap 挤成上下堆叠；
		// 加宽面板并禁止换行，让两列真正并排（参考旧单期组件布局）
		min-width: 200px;

		.h-row-flex {
			flex-wrap: nowrap;

			.h-col {
				flex: 0 0 auto;
			}
		}

		.multi-head {
			padding: 4px 10px;
			border-bottom: 1px solid #eee;

			span {
				margin-right: 12px;
				cursor: pointer;
				color: @primary-color;
			}
		}

		div.selected {
			border-bottom: 1px solid @primary-color;
			color: @primary-color;
			font-weight: bold;
		}

		.split-line {
			border-left: 1px solid @primary-color;
		}

		.list-item {
			li {
				padding: 5px 20px;

				input {
					margin-right: 6px;
				}

				&:hover {
					background-color: #F0F6FF;
					cursor: pointer;
				}

				&.selected {
					background: @primary-color;
					color: @white-color;
				}
			}
		}
	}
</style>
